module.exports = __webpack_public_path__ + "img/e48.ab16e8cf.png";